import { localNow } from "@/filters/DateAndTime";
import SpeechSynthesis from "@/mixins/SpeechSynthesis";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { AudioAlertTracker } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class AudioAlert extends mixins(SpeechSynthesis) {
  @Getter("audioAlertsEnabled", userNamespace)
  audioAlertsEnabled!: boolean;

  @Prop(Object)
  audioAlerts!: Record<string, AudioAlertTracker>;

  @Prop(Number)
  alertRepeatInterval!: number;

  @Prop(Boolean)
  muteOnClick!: boolean;

  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Action("markRead", patientNamespace)
  markRead!: Function;

  mute: boolean = false;

  @Watch("audioAlerts")
  readNewAndRepeatedAudioAlerts() {
    if (this.mute) {
      return;
    }
    // Want to keep track of when this machine has spoken, not sync our times with the server
    const now = localNow();
    if (this.audioAlertsEnabled && this.speechSynthesisEnabled) {
      Object.entries(this.audioAlerts)
        .filter(([_key, a]) => {
          const repeatInterval =
            a.repeatIntervalOverrideMinutes || this.alertRepeatInterval;
          if (repeatInterval === 0) {
            // If repeat is disabled filter out all that have been read before
            if (a.readCount === 0) {
              return true;
            } else {
              return false;
            }
          } else {
            if (!a.firstReadTime) {
              return true;
            }
            // 3rd argument to diff() of true causes output to be floating point
            // default is to floor the output
            const diff = Math.ceil(now.diff(a.firstReadTime, "minute", true));
            const minutesUntilNextReading = repeatInterval * a.readCount;
            return diff >= minutesUntilNextReading;
          }
        })
        .forEach(([key, a]) => {
          this.markRead(key);
          this.speak(`${a.message} . !`);
        });
    }
  }

  @Watch("speechSynthesisEnabled")
  enableAudio() {
    this.readNewAndRepeatedAudioAlerts();
  }

  get showClickToEnable() {
    return this.audioAlertsEnabled && !this.speechSynthesisEnabled;
  }
}
